import { combineReducers } from 'redux';
import { ADD_DEVICES } from '../actions/actiontypes';
import { groupListByProperty, mapValues } from '../../utils/collections';

const mapDeviceToApp = (device) => ({
  ...device,
  buildingId: device.building_id,
});

function addOrUpdateDevices(state, devices) {
  // return the state with the multiple devices added/replaced
  const newState = { ...state };
  for (let i = 0; i < devices.length; i += 1) {
    newState[devices[i].id] = mapDeviceToApp(devices[i]);
  }
  return newState;
}

function devicesById(state = {}, action) {
  switch (action.type) {
    case ADD_DEVICES:
      return addOrUpdateDevices(state, action.devices);
    default:
      return state;
  }
}

function byBuilding(state = {}, action) {
  let devices;
  switch (action.type) {
    case ADD_DEVICES: {
      devices = action.devices;
      break;
    }
    default:
      return state;
  }
  const updates = mapValues(groupListByProperty('building_id', devices), (ps) =>
    ps.map((p) => p.id)
  );
  return { ...state, ...updates };
}

const devicesReducer = combineReducers({
  byId: devicesById,
  byBuilding,
});

export default devicesReducer;
